import(/* webpackMode: "eager" */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSkeleton"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\AboutSkeleton\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutUs"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\AboutUs\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ApplicantCard"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\ApplicantRequest\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogForm"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\BlogForm\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Blogs"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\Blogs\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CareerForm"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\CareerForm\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\Form\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\Globe\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\HeroSection\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroTitle"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\HeroTitle\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["HoverCard"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\HoverCard\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\loginForm\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarDemo"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\Navbar\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\OfficePic\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\Portfolio\\showPortfolio.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\ProjectCards\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewForm"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\ReviewForm\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\ReviewSection\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\Services\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSkeleton"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\SkeletonLoader\\AboutSkeleton.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkeletonLoader"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\components\\SkeletonLoader\\index.js");
